import React, { useState, useEffect } from 'react';
import HeadingArea from '../../general/HeadingArea';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import { MdOutlineEdit } from 'react-icons/md';
import { RiDeleteBin6Line } from 'react-icons/ri';

const ClassSubjects = ({ setLoading }) => {
  const [response2, setResponse2] = useState({ message: '', status: 'success' });
  const [formData, setFormData] = useState({
    name: '',
    sub_type: '',
    sub_code: ''
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [subjects, setSubjects] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
  const [selectedSubjects, setSelectedSubjects] = useState({});
  const [showDelete, setShowDelete] = useState(false);
const [editSubjectId, setEditSubjectId] = useState(null);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEdit = (subject) => {
  setFormData({
    name: subject.sub_name,
    sub_type: subject.sub_type,
    sub_code: subject.sub_code
  });
  setEditSubjectId(subject.id);
  setIsEditMode(true);
};


const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name || !formData.sub_type || !formData.sub_code) {
    setResponse2({ message: 'Please fill all fields.', status: 'error' });
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    return;
  }

  setLoading(true);

  try {
    const url = editSubjectId
      ? `https://api.kcian.in/update-subject/${editSubjectId}`
      : 'https://api.kcian.in/add-subject';

    const method = editSubjectId ? 'PUT' : 'POST';

    const res = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const result = await res.json();

    if (res.ok) {
      fetchSubjects();
      setResponse2({ message: result.message || (editSubjectId ? 'Subject updated!' : 'Subject added!'), status: 'success' });
      setFormData({ name: '', sub_type: '', sub_code: '' });
      setIsEditMode(false);
      setEditSubjectId(null);
    } else {
      setResponse2({ message: result.message || 'Something went wrong.', status: 'error' });
    }
  } catch (err) {
    console.error(err);
    setResponse2({ message: 'Server error occurred.', status: 'error' });
  } finally {
    setLoading(false);
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  }
};


      const fetchSubjects = async () => {
                            setLoading(true);
                    try {
                        const response = await fetch('https://api.kcian.in/get-subjects');
        
                        if (response.ok) {
                            const data = await response.json();
                            setSubjects(data);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch class');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
      }
  
      useEffect(() => {
          fetchSubjects();
      }, []);
  

  const filteredSub = subjects.filter(sub => {
  const term = searchTerm.toLowerCase();
  return (
    sub.sub_name.toLowerCase().includes(term) ||
        sub.sub_code.toLowerCase().includes(term) ||
        sub.sub_type.toLowerCase().includes(term)
  );
});


    const handleShowDelete = (cls) => {
    setSelectedSubjects(cls);
    setShowDelete(true);
  }


              const handleDelete = async (subId) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-subjects/${subId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setSubjects((prevData) => prevData.filter((product) => product.id !== subId));
        setShowDelete(false);
        setResponse2({ message: 'Subject Removed successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting fee particular:', error);
    }
  };




  return (
    <>
    <section className="py-4">
      <div className="px-4">
        <HeadingArea message1="Subjects" message2="All Subjects" />

        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

        <div className='row'>
          <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
            <div className="profile-card">
              <p className="profile-heading">Add Subject</p>

              <form className='mt-4' onSubmit={handleSubmit}>
                {/* Subject Name */}
                <div className="mb-4">
                  <div className="profile-input-area">
                    <label className="profile-badge">Subject Name*</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="profile-input"
                      required
                    />
                  </div>
                </div>

                {/* Subject Type (Radio Buttons) */}
                <div className="mb-4">
                  <div className="profile-input-area pt-4 border-0">
                    <label className="profile-badge">Subject Type*</label>
                    <div>
                      <label className="me-3">
                        <input
                          type="radio"
                          name="sub_type"
                          value="Theory"
                          checked={formData.sub_type === 'Theory'}
                          onChange={handleChange}
                        />{' '}
                        Theory
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="sub_type"
                          value="Practical"
                          checked={formData.sub_type === 'Practical'}
                          onChange={handleChange}
                        />{' '}
                        Practical
                      </label>
                    </div>
                  </div>
                </div>

                {/* Subject Code */}
                <div className="mb-4">
                  <div className="profile-input-area">
                    <label className="profile-badge">Subject Code*</label>
                    <input
                      type="text"
                      name="sub_code"
                      value={formData.sub_code}
                      onChange={handleChange}
                      className="profile-input"
                      required
                    />
                  </div>
                </div>


                <div className='text-center'>
                  <button type="submit" className="profile-btn me-2">
                    {isEditMode ? (
                      <>
                        <AiOutlineEdit /> Update
                      </>
                    ) : (
                      <>
                        <AiOutlinePlus /> Add
                      </>
                    )}
                  </button>

                  {isEditMode && (
                    <button
                      type="button"
                      className="profile-btn2"
                      onClick={() => {
                        setFormData({ name: '', sub_type: '', sub_code: '' });
                        setIsEditMode(false);
                        setEditSubjectId(null);
                      }}
                    >
                      Cancel
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
{/* left ends */}


<div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
<div className='profile-card'>

  <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
            <span className="profile-heading align-content-center">Subject List</span>


                  <div className='profile-input-area ms-auto col-lg-3 border-0'>
<input
  type='text'
  name='search'
  className='profile-input border-bottom rounded-0'
  placeholder='Search Name, Code, Type'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
</div>
  </div>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>S No</th>
    <th>Subject</th>
    <th>Subject Type</th>
    <th>Subject Code</th>
    <th className='rounded-end-4'>Activity</th>
</thead>


{filteredSub.map((sub, index) => (
  <tr className='account-tr'>
    <td>{index+1}</td>
    <td>{sub.sub_name}</td>
    <td>{sub.sub_type}</td>
    <td>{sub.sub_code || '-'}</td>
    <td><MdOutlineEdit className='account-icon1' title='Edit' onClick={() => handleEdit(sub)} /> &nbsp;&nbsp;<RiDeleteBin6Line className='account-icon2' title='Remove' onClick={() => handleShowDelete(sub)} /></td>
  </tr>
))}

</table>
</div>
{/* table ends */}



</div>
</div>
{/* right ends */}

        </div>
{/* row ends */}

      </div>
    </section>
    
          {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Subject!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Subject</th>
    <th>Subject Type</th>
    <th className='rounded-end-4'>Subject Code</th>
</thead>

<tr className='account-tr'>
<td>{selectedSubjects.sub_name}</td>
<td>{selectedSubjects.sub_type}</td>
<td>{selectedSubjects.sub_code}</td>
</tr>

</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Subject will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedSubjects.id)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}
    </>
  );
};

export default ClassSubjects;
